import {Banner} from '@primer/react'

export function ReferenceSizeExceededBanner() {
  return (
    <Banner
      title="Reference size exceeded"
      variant="critical"
      description="You've exceeded the size limit for this space. Remove some references to continue."
      hideTitle
      className="tmp-mb-3"
    />
  )
}
